/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES, LOSS OF USE, DATA, OR
 *  PROFITS, OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Metrics Constants declaration
 * @ignore
 */
export default {
    TCP_CONNECTION : 'TcpList',
    HTTP_REQUEST : 'HttpList',
    TRACK_SWITCH : 'RepSwitchList',
    BUFFER_LEVEL : 'BufferLevel',
    BUFFER_LOADED : 'bufferLoaded',
    ABANDON_LOAD : 'abandonload',
    ALLOW_LOAD : 'allowload',
    BUFFER_EMPTY : 'bufferStalled',
    BUFFER_STATE : 'BufferState',
    DVR_INFO : 'DVRInfo',
    DROPPED_FRAMES : 'DroppedFrames',
    SCHEDULING_INFO : 'SchedulingInfo',
    REQUESTS_QUEUE : 'RequestsQueue',
    MANIFEST_UPDATE : 'ManifestUpdate',
    MANIFEST_UPDATE_STREAM_INFO : 'ManifestUpdatePeriodInfo',
    MANIFEST_UPDATE_TRACK_INFO : 'ManifestUpdateRepresentationInfo',
    PLAY_LIST : 'PlayList',
    DVB_ERRORS : 'DVBErrors',
    HTTP_REQUEST_DVB_REPORTING_TYPE : 'DVBReporting',
}





